<template>
	<div class="user-activity" :style="{ transform: openDrawer ? 'translateY(100%)' : 'translateY(0%)' }">


		<LiveUserActivityToggleButton />
		<UserLiveActivities />


	</div>
</template>



<script setup>

import { ref, watch, provide } from "vue";
import { isDesktop } from "@/utils/utils.ts";
import UserLiveActivities from './Users-Live-Activities.vue';
import LiveUserActivityToggleButton from './User-Live-Activity-Toggle-Button.vue';

const isDesktopDevice = isDesktop();
let openDrawer = ref(false);

watch(isDesktopDevice, newValue => {
  openDrawer.value = newValue;
});

provide('openDrawer', openDrawer);

</script>